export const INTEGRATION_NAMES = {
  DrHorton: "DrHorton",
  JdEdwards: "JdEdwards",
};
